export const ORDER_COBRO_COACTIVO: string[] = [
  'MANDAMIENTO DE PAGO',
  'CITACION MANDAMIENTO',
  'CITACIONES GENERADAS',
  'CARGUE DE GUIAS',
  'NOTIFICACION MANDAMIENTO',
  'RESOLUCION AVANTE',
  'RESOLUCION MEDIDAS CAUTELARES',
  'EMBARGO',
  'CONSULTAR COBRO COACTIVO',
];
